import React, { useState, useEffect } from "react";
import axios from "axios";
import "./HandEyeTest.css"

const HandEyeTest = () => {

  const totalBalls = 20;
  const ballSize = 80;
  const delay = 700;

  const [ball, setBall] = useState(null);
  const [currentBall, setCurrentBall] = useState(0);
  const [trials, setTrials] = useState([]);
  const [startTime, setStartTime] = useState(null);
  const [running, setRunning] = useState(false);

  const [page, setPage] = useState("game");
  const [resultData, setResultData] = useState(null);

  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);

  const colors = ["green", "red", "blue"];

  /* START GAME */
  useEffect(() => {
    setTimeout(startGame, 400);
  }, []);
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });

  const startGame = () => {
    setCurrentBall(0);
    setTrials([]);
    setRunning(true);
    setPage("game");
    showBall(0);
  };

  /* SHOW BALL */
  const showBall = (ballIndex) => {

    if (ballIndex >= totalBalls) {
      finishTest();
      return;
    }

    const w = window.innerWidth;
    const h = window.innerHeight;

    const x = Math.random() * (w - ballSize);
    const y = Math.random() * (h - ballSize - 80) + 80;

    const color = colors[Math.floor(Math.random() * colors.length)];

    setBall({ x, y, color });
    setStartTime(performance.now());
  };

  /* CLICK HANDLER — left click = right hand, right click = left hand */
  const handleClick = (e) => {

    e.preventDefault();
    e.stopPropagation();

    if (!running || !ball) return;

    // button 0 = left click → right hand
    // button 2 = right click → left hand
    const side = e.button === 2 ? "left" : "right";

    const reaction = (performance.now() - startTime) / 1000;

    const trial = {
      ballNumber: currentBall + 1,
      reaction: Number(reaction.toFixed(3)),
      timestamp: new Date().toISOString(),
      color: ball.color,
      x: Math.round(ball.x),
      y: Math.round(ball.y),
      side
    };

    setTrials(prev => [...prev, trial]);

    const next = currentBall + 1;
    setCurrentBall(next);
    setBall(null);

    setTimeout(() => showBall(next), delay);
  };

  /* SAVE */
  const saveReactionResult = async (data) => {
    try {

      const payload = {
        email: localStorage.getItem("rg_email"),
        trials: data,
        age: null
      };

      const res = await axios.post(
        "/api/save-hand-eye-response-time",
        payload
      );

      setResultData(res.data);

    } catch (error) {
      console.error("SAVE ERROR:", error.response?.data || error);
    }
  };

  /* LEADERBOARD */
  const fetchLeaderboard = async () => {
    try {

      const email = localStorage.getItem("rg_email");

      const res = await axios.get(
        `/api/hand-eye-response-timeleaderboard?email=${email}`
      );

      setLeaderboard(res.data.leaderboard || []);
      setUserRank(res.data.userRank);

    } catch (error) {
      console.error(error);
    }
  };

  /* FINISH */
  const finishTest = async () => {

    setRunning(false);
    setBall(null);

    if (trials.length === 0) return;

    await saveReactionResult(trials);
    await fetchLeaderboard();

    setPage("result");
  };

  /* TRY AGAIN */
  const handleTryAgain = () => {
    startGame();
  };

  /* ================= RESULT UI ================= */

  if (page === "result") {
    return (
      <div className="result-big-container">

        {/* LEFT */}
        <div className="leaderboard-box">

          <h3>🏆 Leaderboard</h3>

          <table className="leaderboard-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Name</th>
                <th>Best</th>
                <th>Medal</th>
              </tr>
            </thead>

            <tbody>
              {leaderboard.slice(0, 5).map((player, index) => {

                let medal = "";
                if (index === 0) medal = "🥇";
                else if (index === 1) medal = "🥈";
                else if (index === 2) medal = "🥉";

                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{player.name}</td>
                    <td>{(player.bestReaction * 1000).toFixed(0)} ms</td>
                    <td>{medal}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {userRank && (
            <div className="your-rank-box">
              <p><b>Your Rank:</b> {userRank.rank}</p>
              <p>
                <b>Your Best:</b>{" "}
                {(userRank.bestReaction * 1000).toFixed(0)} ms
              </p>
            </div>
          )}

        </div>

        {/* RIGHT */}
        <div className="results-box">

          <h2>🎯 Your Results</h2>

          <div className="result-card">
            <p>
              <span>Average</span>
              <b>{(resultData?.averageReaction * 1000).toFixed(0)} ms</b>
            </p>

            <p>
              <span>Best</span>
              <b>{(resultData?.bestReaction * 1000).toFixed(0)} ms</b>
            </p>

            <p>
              <span>Dominant</span>
              <b>{resultData?.dominantHand}</b>
            </p>
          </div>

          <div className="button-group">
            <button onClick={handleTryAgain} className="try-again-buttonr">
              Try Again
            </button>

            <button
              onClick={() => window.location.href = "/dashboard"}
              className="exit-buttonr"
            >
              Exit
            </button>
          </div>

        </div>

      </div>
    );
  }

  /* ================= GAME UI ================= */

  return (
    <div className="container">

      <div className="status">
        Playing — {currentBall} / {totalBalls}
      </div>

      {ball && (
        <div
          className="ball"
          onClick={handleClick}
          onContextMenu={handleClick}
          style={{
            left: ball.x,
            top: ball.y,
            width: ballSize,
            height: ballSize,
            background: ball.color
          }}
        />
      )}

    </div>
  );
};

export default HandEyeTest;
